import React, { ReactElement, ReactNode } from 'react';
import styled from 'styled-components';

import { FormElement } from '../Form';
import { Label } from '../Label';

export interface LabeledProps {
  label: string | ReactNode;
  placeholder?: string;
  name?: string;
  children: ReactNode;
  isInverted?: boolean;
  isGrey?: boolean;
  className?: string;
  testId?: string;
  isRequired?: boolean;
}

export const Labeled = ({
  children,
  isInverted,
  isGrey,
  label,
  name,
  className,
  testId,
  isRequired,
  ...rest
}: LabeledProps) => {
  const child = React.Children.toArray(children)[0];
  const component = React.cloneElement(
    child as ReactElement<FormElement<object>>,
    {
      isInverted,
      name,
      ...rest,
    },
  );

  return (
    <LabeledWrapper className={className}>
      <Label
        testId={testId}
        isInverted={isInverted}
        isGrey={isGrey}
        text={label}
        htmlFor={name}
        isRequired={isRequired}
      />
      {component}
    </LabeledWrapper>
  );
};

const LabeledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border: none;
  margin: 8px 0;
  padding: 0;
  min-width: auto;
  font-family: 'Open Sans', sans-serif;
`;
